import { createSlice } from '@reduxjs/toolkit'
import { DEFAULT_VARIANT, GAME_PHASE, VARIANT_META } from '../constants'
import { getMyBets, getTopBets, placeBet } from './threeKingsScratch.thunk'

const initialState = {
  selectedAmount: VARIANT_META[DEFAULT_VARIANT]?.fixedBet || 5,
  selectedVariant: DEFAULT_VARIANT,
  gamePhase: GAME_PHASE.IDLE,
  betLock: false,
  lastRound: null,
  lastWinAmount: 0,
  currentMultiplier: 0,
  myBetsData: [],
  topBetsData: [],
  autoplayRunning: false,
  autoplayRemaining: 0,
  turbo: false
}

const threeKingsScratchSlice = createSlice({
  name: 'threeKingsScratch',
  initialState,
  reducers: {
    setSelectedAmount: (state, action) => {
      state.selectedAmount = action.payload
    },
    setSelectedVariant: (state, action) => {
      state.selectedVariant = action.payload
      state.selectedAmount = VARIANT_META[action.payload]?.fixedBet || 5
    },
    setGamePhase: (state, action) => {
      state.gamePhase = action.payload
    },
    setBetLock: (state, action) => {
      state.betLock = action.payload
    },
    setTurbo: (state, action) => {
      state.turbo = Boolean(action.payload)
    },
    setAutoplayRunning: (state, action) => {
      state.autoplayRunning = action.payload
    },
    setAutoplayRemaining: (state, action) => {
      state.autoplayRemaining = action.payload
    },
    stopAutoplay: (state) => {
      state.autoplayRunning = false
      state.autoplayRemaining = 0
      state.turbo = false
    },
    resetRoundVisuals: (state) => {
      state.gamePhase = GAME_PHASE.IDLE
      state.betLock = false
      state.lastRound = null
      state.currentMultiplier = 0
    },
    appendRoundBet: (state, action) => {
      const bet = action.payload
      if (!bet) return
      state.myBetsData = [bet, ...state.myBetsData]
      const winAmount = Number(bet.winningAmount ?? bet.winAmount ?? 0)
      if (winAmount > 0) {
        state.topBetsData = [bet, ...state.topBetsData]
          .sort((a, b) => Number(b.winningAmount ?? b.winAmount ?? 0) - Number(a.winningAmount ?? a.winAmount ?? 0))
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(placeBet.pending, (state) => {
        state.betLock = true
        state.lastRound = null
      })
      .addCase(placeBet.fulfilled, (state, action) => {
        const round = action.payload?.round
        const betRecord = action.payload?.betRecord
        state.lastRound = round
        state.lastWinAmount = Number(round?.winningAmount || 0)
        state.currentMultiplier = Number(round?.multiplier || 0)
        state.betLock = false
        state.gamePhase = GAME_PHASE.SCRATCHING
        if (betRecord) {
          state.myBetsData = [betRecord, ...state.myBetsData]
          const winAmount = Number(betRecord.winningAmount ?? betRecord.winAmount ?? 0)
          if (winAmount > 0) {
            state.topBetsData = [betRecord, ...state.topBetsData]
              .sort((a, b) => Number(b.winningAmount ?? b.winAmount ?? 0) - Number(a.winningAmount ?? a.winAmount ?? 0))
          }
        }
      })
      .addCase(placeBet.rejected, (state) => {
        state.betLock = false
        state.gamePhase = GAME_PHASE.IDLE
      })
      .addCase(getMyBets.fulfilled, (state, action) => {
        state.myBetsData = action.payload
      })
      .addCase(getMyBets.rejected, (state) => {
        state.myBetsData = []
      })
      .addCase(getTopBets.fulfilled, (state, action) => {
        state.topBetsData = action.payload
      })
      .addCase(getTopBets.rejected, (state) => {
        state.topBetsData = []
      })
  }
})

export const {
  setSelectedAmount,
  setSelectedVariant,
  setGamePhase,
  setBetLock,
  setTurbo,
  setAutoplayRunning,
  setAutoplayRemaining,
  stopAutoplay,
  resetRoundVisuals,
  appendRoundBet
} = threeKingsScratchSlice.actions

export default threeKingsScratchSlice.reducer
